'use client';

import type { Member } from '@slims/shared/types';
import { Stack } from '@slims/ui/atoms';
import { StatusBlock } from '@slims/ui/molecules';
import { Section } from '@/components/admin/detail-fields';
import { type AssociateUserBody, MemberUserForm } from '@/components/members/member-user-form';

interface UtenteTabProps {
	member: Member | null;
	onAssociateUser: (memberId: string, body: AssociateUserBody) => Promise<Member>;
	/** Ricarica il socio dopo il collegamento, così lo stato «già collegato» è subito vero. */
	onLinked: () => void;
}

/**
 * Tab — Utente: l'account con cui il socio accede al proprio portale.
 *
 * Era un pulsante nella riga dell'elenco soci, che apriva un dialog. Una riga di
 * tabella non è il posto di un'operazione che crea credenziali: si perdeva fra
 * altre tre CTA, e il dialog copriva proprio i dati — email, stato — che servono
 * per decidere. Qui sta accanto a loro, nella scheda del socio a cui l'account
 * appartiene.
 */
export function UtenteTab({ member, onAssociateUser, onLinked }: UtenteTabProps) {
	if (!member) {
		return <StatusBlock kind="loading" message="Caricamento…" />;
	}

	return (
		<Stack gap="lg">
			<Section
				title="Account portale"
				hint={
					member.userId
						? 'Il socio ha un account e può accedere al portale.'
						: 'Il socio non ha ancora un account: senza, non può accedere al portale.'
				}
			>
				<MemberUserForm member={member} onSubmit={onAssociateUser} onDone={onLinked} />
			</Section>
		</Stack>
	);
}
